<template>
  <v-container fluid>
    <v-dialog v-model="dialogReusePlan" width="800">
      <template v-slot:activator="{ on, attrs }">
        <v-icon v-bind="attrs" v-on="on"> </v-icon>
      </template>
      <v-card>
        <v-data-table
          :headers="lessonPlanHeaders"
          :items="availablePlansForReuse"
          :items-per-page="20"
          item-key="id"
          group-by="unit.objective"
          class="elevation-1"
          show-group-by
        >
          <template
            v-slot:[`group.header`]="{ group, headers, toggle, isOpen }"
          >
            <td :colspan="headers.length">
              <v-btn
                @click="toggle"
                small
                icon
                :ref="group"
                :data-open="isOpen"
              >
                <v-icon v-if="isOpen">mdi-chevron-up</v-icon>
                <v-icon v-else>mdi-chevron-down</v-icon>
              </v-btn>
              <span style="font-weight: bold"> {{ group.toUpperCase() }} </span>
            </td>
          </template>
          <template v-slot:[`item.created_at`]="{ item }">
            <v-chip>{{
              new Date(item.created_at).toLocaleDateString()
            }}</v-chip>
          </template>
          <template v-slot:[`item.unit`]="{ item }">
            <v-chip>{{ item.unit.objective }}</v-chip>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-icon small class="mr-2" @click="reuseSelectedPlan(item)">
              mdi-launch
            </v-icon>
          </template>
        </v-data-table>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDelete" width="600">
      <template v-slot:activator="{ on, attrs }">
        <v-icon v-bind="attrs" v-on="on"> </v-icon>
      </template>
      <v-card>
        <v-card-title>
          <v-toolbar dark color="red"> Delete Plan </v-toolbar>
        </v-card-title>
        <v-card-text v-if="isPlanMaster">
          Caution: This is a reusable master plan, are you sure?
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn @click="(deletePlanId = null), (dialogDelete = false)">
            Cancel
          </v-btn>
          <v-btn @click="removeExistingPlan(), (dialogDelete = false)"
            >Delete</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogMakeMaster" width="600">
      <template v-slot:activator="{ on, attrs }">
        <v-icon v-bind="attrs" v-on="on"> </v-icon>
      </template>
      <v-card>
        <v-card-title>
          <v-toolbar dark color="green"> Save as Master </v-toolbar>
        </v-card-title>
        <v-card-text>
          This plan will be saved as master and be available for reuse
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn @click="dialogMakeMaster = false"> Cancel </v-btn>
          <v-btn @click="makePlanMaster()">Save as Master</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogNewEditPlan" width="800" scrollable persistent>
      <template v-slot:activator="{ on, attrs }">
        <v-icon v-bind="attrs" v-on="on"> </v-icon>
      </template>
      <v-card>
        <v-toolbar class="headline grey lighten-2">
          Add New Plan
          <v-spacer></v-spacer>
          <v-btn text @click="dialogNewEditPlan = false"> Cancel </v-btn>
          <v-btn color="primary" dark @click="savePlan"> Save Plan </v-btn>
        </v-toolbar>

        <v-card-text class="mt-5">
          <v-row>
            <v-container fluid>
              <v-card outlined>
                <v-toolbar dark dense>Lesson Plan Header</v-toolbar>
                <v-container fluid>
                  <v-row>
                    <v-col cols="12" md="8" lg="8">
                      <v-text-field
                        autocomplete="off"
                        placeholder="Title"
                        v-model="editedLessonPlan.title"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4" lg="4">
                      <v-select
                        v-model="editedLessonPlan.unit"
                        :items="units"
                        item-text="objective"
                        item-value="phaseRank"
                        label="Units"
                        return-object
                        clearable
                      >
                      </v-select>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="12" lg="12">
                      <v-text-field
                        autocomplete="off"
                        v-model="editedLessonPlan.essential_question"
                        placeholder="Essential Question/Lesson Objective"
                        dense
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="12" lg="12">
                      <v-select
                        v-model="editedLessonPlan.standards"
                        :items="standards"
                        item-text="objective"
                        item-value="phaseRank"
                        return-object
                        multiple
                        label="Learning Standards"
                        dense
                      >
                        <template v-slot:selection="{ item, index }">
                          {{ index + 1 }}) {{ item.objective }}<br />
                        </template>
                      </v-select>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card>
            </v-container>
          </v-row>
          <v-row>
            <v-container fluid>
              <v-card outlined>
                <v-toolbar dark dense>Lesson Plan Content</v-toolbar>

                <v-col
                  v-for="(content, id) in editedLessonPlan.contents"
                  :key="id"
                  cols="12"
                  md="12"
                  lg="12"
                >
                  <v-card class="mt-3" outlined>
                    <v-toolbar color="grey lighten-2" dense>
                      <v-combobox
                        v-model="content.type"
                        :items="contentOptions"
                        label="Content Type"
                        solo
                        dense
                        class="mb-n6"
                      ></v-combobox>
                      <v-spacer />
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-if="content.visible"
                            v-bind="attrs"
                            v-on="on"
                            class="mr-5"
                            @click="content.visible = false"
                            >mdi-eye</v-icon
                          >

                          <v-icon
                            v-else
                            v-bind="attrs"
                            v-on="on"
                            class="mr-5"
                            @click="content.visible = true"
                            >mdi-eye-off</v-icon
                          >
                        </template>
                        <span>Visible to Students:{{ content.visible }}</span>
                      </v-tooltip>
                      <v-btn icon @click="deleteContent(id)">
                        <v-icon>mdi-delete</v-icon></v-btn
                      >
                    </v-toolbar>

                    <v-card-text class="pa-0">
                      <div class="mx-0 px-0">
                        <!-- Use the component in the right place of the template -->
                        <tiptap-vuetify
                          v-model="content.content"
                          :extensions="extensions"
                        />
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-card-actions>
                  <v-spacer />
                  <v-btn
                    v-if="editedLessonPlan.contents"
                    @click="addContent()"
                    color="blue-grey"
                    class="mx-auto white--text"
                    ><v-icon dark class="mx-3"> mdi-plus </v-icon> Add
                    {{ editedLessonPlan.contents.length > 0 ? "More" : "" }}
                    Content
                  </v-btn>
                  <v-spacer />
                </v-card-actions>
              </v-card>
            </v-container>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <div class="text-center">
      <v-container fluid>
        <v-card
          max-width="900"
          class="mx-auto mb-8"
          elevation="5"
          v-for="existingPlan in ExistingLessonPlans"
          :key="existingPlan.id"
        >
          <v-toolbar class="headline grey lighten-2">
            Lesson Plan
            <v-icon v-if="existingPlan.master_id == null"> mdi-archive</v-icon>
            <v-icon
              v-else
              @click="editExistingPlan(existingPlan), (dialogMakeMaster = true)"
              >mdi-recycle
            </v-icon>
            <v-spacer></v-spacer>
            <v-btn
              text
              @click="
                (deletePlanId = existingPlan.id),
                  existingPlan.master_id == null
                    ? (isPlanMaster = true)
                    : (isPlanMaster = false),
                  (dialogDelete = true)
              "
            >
              Remove Plan
            </v-btn>
            <v-btn
              color="primary"
              dark
              @click="
                (dialogNewEditPlan = true), editExistingPlan(existingPlan)
              "
            >
              Edit Plan
            </v-btn>
            <v-btn
              class="ml-2"
              color="primary"
              dark
              target="_blank"
              :href="`https://sis-api${domain}/my-schedule/print-content?course_id=${$store.state.course.course_id}&section=${$store.state.course.section}&date=${$store.state.course.start.substr(0, 10)}&period=${$store.state.course.period}`"
            >
              PDF
            </v-btn>
          </v-toolbar>

          <v-card-text class="mt-5">
            <v-row>
              <v-container fluid>
                <v-card outlined>
                  <v-toolbar dark dense>Lesson Plan Header</v-toolbar>
                  <v-container fluid>
                    <v-row>
                      <v-col cols="12" md="12" lg="12" class="text-h5 pa-0">
                        Title: {{ existingPlan.title }}
                      </v-col>
                      <v-col cols="12" md="12" lg="12" class="py-0">
                        Unit:
                        {{
                          existingPlan.unit ? existingPlan.unit.objective : ""
                        }}
                      </v-col>

                      <v-col cols="12" md="12" lg="12" class="py-0">
                        Learning Objective/Essential Question:
                        {{ existingPlan.essential_question }}
                      </v-col>

                      <v-col cols="12" md="12" lg="12" class="py-0">
                        Learning Standards:
                        <v-list dense>
                          <v-list-item
                            dense
                            v-for="standard in existingPlan.standards"
                            :key="standard.phaseRank"
                          >
                            {{ standard.objective }}
                          </v-list-item>
                        </v-list>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card>
              </v-container>
            </v-row>
            <v-row>
              <v-container fluid>
                <v-card outlined>
                  <v-toolbar dark dense>Lesson Plan Content</v-toolbar>

                  <v-col
                    v-for="(content, id) in existingPlan.contents"
                    :key="id"
                    cols="12"
                    md="12"
                    lg="12"
                  >
                    <v-card outlined>
                      <v-toolbar color="grey lighten-2" dense>
                        <v-toolbar-title>
                          {{ content.type ? content.type : "Untitled" }}
                        </v-toolbar-title>
                      </v-toolbar>
                      <v-card-text v-html="content.content"></v-card-text>
                    </v-card>
                  </v-col>
                </v-card>
              </v-container>
            </v-row>
          </v-card-text>
        </v-card>
      </v-container>
    </div>
    <div class="text-center">
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn color="primary" dark v-bind="attrs" v-on="on">
            <v-icon left> mdi-plus </v-icon>
            Lesson Plan
          </v-btn>
        </template>
        <v-list dense>
          <v-list-item dense @click="addNewPlan()">
            <v-list-item-icon>
              <v-icon color="primary"> mdi-file-document </v-icon>
            </v-list-item-icon>
            <v-list-item-content> Add New </v-list-item-content>
          </v-list-item>
          <v-list-item dense @click="dialogReusePlan = true">
            <v-list-item-icon>
              <v-icon> mdi-replay </v-icon>
            </v-list-item-icon>
            <v-list-item-content> Re-use</v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>
    <div class="text-center">
      <v-snackbar v-model="snackbar" :multi-line="true">
        {{ snackbarMessage }}
        <template v-slot:action="{ attrs }">
          <v-btn color="red" text v-bind="attrs" @click="snackbar = false">
            Close
          </v-btn>
        </template>
      </v-snackbar>
    </div>
  </v-container>
</template>

<script>
import {
  TiptapVuetify,
  Heading,
  Bold,
  Italic,
  Strike,
  Underline,
  Code,
  Paragraph,
  BulletList,
  OrderedList,
  ListItem,
  Link,
  Blockquote,
  HardBreak,
  HorizontalRule,
  History,
} from "tiptap-vuetify";
export default {
  components: { TiptapVuetify },
  data: () => ({
    units: [],
    standards: [],
    ExistingLessonPlans: [],
    isPlanMaster: false,
    clickedPlanId: null,
    deletePlanId: null,
    dialogDelete: false,
    dialogNewEditPlan: false,
    dialogReusePlan: false,
    dialogMakeMaster: false,
    availablePlansForReuse: [],
    blakLessonPlan: {
      id: null,
      title: null,
      essential_question: null,
      author_user_id: null,
      contents: [],
      unit: {},
      standards: [],
    },
    editedLessonPlan: {},
    content: {
      type: "",
      visible: true,
      content: `
              <h1>My content </h1>
              <p>My content details </p>`,
    },
    contentOptions: [
      "Intro (Hook / Do Now)",
      "Teaching & Instruction",
      "Student Learning Activity ",
      "Graded / Ungraded work",
    ],
    lessonPlanHeaders: [
      { text: "Title", value: "title", groupable: false },
      { text: "Objective", value: "essential_question", groupable: false },
      { text: "Author", value: "author_full_name", groupable: false },
      { text: "Date Created", value: "created_at", groupable: false },
      { text: "Actions", value: "actions", sortable: false, groupable: false },
    ],
    // declare extensions you want to use
    extensions: [
      History,
      Blockquote,
      Link,
      Underline,
      Strike,
      Italic,
      ListItem,
      BulletList,
      OrderedList,
      [
        Heading,
        {
          options: {
            levels: [1, 2, 3],
          },
        },
      ],
      Bold,
      Code,
      HorizontalRule,
      Paragraph,
      HardBreak,
    ],
    snackbar: false,
    snackbarMessage: "",
  }),
  computed: {
    domain() {
      let parts = process.env.VUE_APP_API_URL.split(".");
      return "." + parts[1] + "." + parts[2];
    },
  },
  methods: {
    addNewPlan() {
      this.editedLessonPlan = { ...this.blakLessonPlan };
      this.editedLessonPlan.contents = [...this.blakLessonPlan.contents];
      this.editedLessonPlan.unit = { ...this.blakLessonPlan.unit };
      this.editedLessonPlan.standards = [...this.blakLessonPlan.standards];

      this.dialogNewEditPlan = true;
    },
    editExistingPlan(existingPlan) {
      this.editedLessonPlan = { ...existingPlan };
      this.editedLessonPlan.contents = [...existingPlan.contents];
      this.editedLessonPlan.unit = { ...existingPlan.unit };
      this.editedLessonPlan.standards = [...existingPlan.standards];
    },
    removeExistingPlan() {
      this.$sisApi("delete", `my-schedule/content/${this.deletePlanId}`)
        .then(() => {
          const index = this.ExistingLessonPlans.findIndex(
            (plan) => plan.id === this.deletePlanId
          );
          this.ExistingLessonPlans.splice(index, 1);
          //remove plan from existing plans
        })
        .catch((error) => {
          this.snackbarMessage = error.response.data.message;
          this.snackbar = true;
          console.log(error);
        });
    },
    reuseSelectedPlan(item) {
      item.master_id = item.id;
      item.id = null;
      item.section = this.$store.state.course.section;
      item.period = this.$store.state.course.period;
      item.date = this.$store.state.course.start.substr(0, 10);
      this.$sisApi("post", `my-schedule/content`, item)
        .then((response) => {
          this.ExistingLessonPlans.push(response.data);
          this.dialogReusePlan = false;
        })
        .catch((error) => {
          this.snackbarMessage = error.response.data.message;
          this.snackbar = true;
          console.log(error);
        });
    },
    makePlanMaster() {
      this.editedLessonPlan.master_id = null;
      this.$sisApi("put", `my-schedule/content`, this.editedLessonPlan)
        .then((response) => {
          const index = this.ExistingLessonPlans.findIndex(
            (plan) => plan.id === this.editedLessonPlan.id
          );

          this.ExistingLessonPlans.splice(index, 1, response.data);
          //replace edited lesson plan
          this.dialogMakeMaster = false;
        })
        .catch((error) => {
          this.snackbarMessage = error.response.data.message;
          this.snackbar = true;
          console.log(error);
        });
    },
    savePlan() {
      if (this.editedLessonPlan.id === null) {
        this.editedLessonPlan.course_id = this.$store.state.course.course_id;
        this.editedLessonPlan.section = this.$store.state.course.section;
        this.editedLessonPlan.period = this.$store.state.course.period;
        this.editedLessonPlan.date = this.$store.state.course.start.substr(0, 10);
        this.$sisApi("post", `my-schedule/content`, this.editedLessonPlan)
          .then((response) => {
            this.ExistingLessonPlans.push(response.data);
            this.dialogNewEditPlan = false;
          })
          .catch((error) => {
            this.snackbarMessage = error.response.data.message;
            this.snackbar = true;
            console.log(error);
          });
      } else {
        this.$sisApi("put", `my-schedule/content`, this.editedLessonPlan)
          .then((response) => {
            const index = this.ExistingLessonPlans.findIndex(
              (plan) => plan.id === this.editedLessonPlan.id
            );

            this.ExistingLessonPlans.splice(index, 1, response.data);
            //replace edited lesson plan
            this.dialogNewEditPlan = false;
          })
          .catch((error) => {
            this.snackbarMessage = error.response.data.message;
            this.snackbar = true;
            console.log(error);
          });
      }
    },
    addContent() {
      this.editedLessonPlan.contents.push({ ...this.content });
    },
    deleteContent(id) {
      this.editedLessonPlan.contents.splice(id, 1);
    },

    getExistingLessonPlans() {
      this.$sisApi("get", "my-schedule/content", {
        course_id: this.$store.state.course.course_id,
        section: this.$store.state.course.section,
        date: this.$store.state.course.start.substr(0, 10),
        period: this.$store.state.course.period,
      }).then((response) => {
        this.ExistingLessonPlans = response.data;
      });
    },
  },
  mounted() {
    this.getExistingLessonPlans();

    this.$sisApi(
      "get",
      `my-schedule/contents/${this.$store.state.course.course_id}`
    ).then((response) => {
      this.availablePlansForReuse = response.data.filter(
        (plan) => plan.master_id == null
      );
    });

    this.$sisApi(
      "get",
      `my-schedule/course/${this.$store.state.course.course_id}`
    )
      .then((response) => {
        this.units = response.data.units;
        this.standards = response.data.standards;
      })
      .catch((error) => {
        this.snackbar = true;
        this.snackbarMessage = error.response.data.message;
        console.log(error);
      });
  },
};
</script>
